import Immutable from 'immutable';

const LOAD = 'constitution/LOAD';
const LOAD_SUCCESS = 'constitution/LOAD_SUCCESS';
const LOAD_FAIL = 'constitution/LOAD_FAIL';
const PATIENT_VISITS = 'constitution/PATIENT_VISITS';


const initialState = Immutable.fromJS({
    isLoad: false,
    loadErr: null,
    loading: false,
    constitution: [],
    patientVisits:{},
});


export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD:
            return state
                .set('isLoad', true)
                .set('loadErr', null)
                .set('constitution', action.result)

        case LOAD_SUCCESS:
            return state
                .set('isLoad', false)
                .set('loadErr', null);

        case LOAD_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('constitution', action.result);
        case PATIENT_VISITS:
            return state
                .set('isLoad', false)
                .set('loadErr', null)
                .set('patientVisits', action.result);
        default:
            return state;
    }
};


export const sendClinicalConstitution = (details) => async (dispatch, getState, api) => {
    try {
        let res = await api.post('/clinicalConstitution/sendClinicalConstitution',{ data: details });
        return res;
    } catch (err) {
        dispatch({ type: LOAD, error: err.message });
    }
};


export const getAllClinicalConstitution = (details) => async (dispatch, getState, api) =>{
    try {
        await api.post('/clinicalConstitution/getAllClinicalConstitution',{ data: details })
            .then(res => {
                    dispatch({ type:LOAD, result: res,});
            });

    } catch (error) {
        dispatch({ type: LOAD, error: error.message});
        return error
    }
}


export const uploadClinicalConstitution = (details) => async (dispatch, getState, api) => {
    try {
        let res = await api.post('/clinicalConstitution/uploadClinicalConstitution',{ data: details })
        return res
    } catch (error) {
        return error
    }
}

export const setClinicalConstitution = (details) => async (dispatch, getState, api) => {
    try {
        let res = await api.put('/clinicalConstitution/setClinicalConstitution',{ data: details })
        dispatch({ type:LOAD, result: []});
        return (res);
    } catch (error) {
        return error
    }
}


export const archiveClinicalConstitution = (details) => async (dispatch, getState, api) => {
    try {
        let res = await api.put('/clinicalConstitution/archiveClinicalConstitution',{ data: details })
        dispatch({ type:LOAD, result: []});
        return (res);
    } catch (error) {
        return error
    }
}

export const getNumberPatience = ( url) => async (dispatch, getState, api) => {
    try {
        const data ={
            patientVisits: 0,
            patientsPerDay: 0,
            actionItems: []
        }
        dispatch({ type:LOAD, result: []});
        const res = await api.get(url);
        if(res && res.production && res.production && res.production.reportData ){
            const reportData =res.production.reportData;
            const keys=Object.keys(reportData);

            keys.forEach(key=>{
                data.patientVisits+=reportData[key].length;
            })
            const num = keys.length>0?keys.length:1;
            data.patientsPerDay=Math.ceil(data.patientVisits/num)
        }
        dispatch({ type:PATIENT_VISITS, result: data});
        return data;
    } catch (error) {

        return error
    }
};

